import React from 'react';
import { Atom } from 'AppReact';
import Cards from 'react-credit-cards'

export default Atom({ type: 'custom', dataType: 'string', template: Cards });
